var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$root.$data.pageSnippets)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.$root.$data.pageSnippets[_vm.name])}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }